import React, { useEffect } from 'react';
import { Row, Col, Input } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { changeSearchOptions } from '../../../../store/ducks/pesquisa';
import { Store } from '../../../../store';
import { useAccessibilityContext } from '../../../consulta-acessibilidade/contexts/AccessibilityContext';
import Button from '../../../consulta-acessibilidade/Button';
import { useSearchContext } from '../../../../shared/contexts/SearchContextProvider';
import { useAppContext } from '../../../../shared/contexts/AppContextProvider';
import Axios from 'axios';

const PesquisaNovasAquisicoes = ({
    opcoesConsulta,
    error,
    loading
}) => {
    const { t } = useTranslation();
    const { searchInputRef } = useAccessibilityContext();
    const { search } = useSearchContext();
    const { selectedTab} = useAppContext()

    //? Valores dentro do select:
    const termos = [
        { label: t('TITULO'), value: 'TITULO' },
        { label: t('ASSUNTO'), value: 'ASSUNTO' },
        { label: t('AUTOR'), value: 'AUTOR' },
    ];

    //Efeito para executar a pesquisa automática de novas aquisições.
    useEffect(() => {
        const cancelTokenSrc = Axios.CancelToken.source()
        const { token } = cancelTokenSrc
        if(selectedTab === 'novas_aquisicoes'){
            search({
                coluna_um: 'TODOS'
            }, {
                for: 'TODOS'
            }, token)
        }

        return () => {
            cancelTokenSrc.cancel()
        }
    }, [selectedTab]);

    const handleTextChange = e => {
        e.preventDefault();
        const { target: { value: valor} } = e;
        const optPesquisa = opcoesConsulta;
        optPesquisa[0].termo = valor;
        return Store.dispatch(changeSearchOptions(optPesquisa));
    };

    const handleComboChange = e => {
        e.preventDefault();
        const { target: { value: valor} } = e;
        const optPesquisa = opcoesConsulta;
        optPesquisa[0].option = valor;
        return Store.dispatch(changeSearchOptions(optPesquisa));
    };

    return (
        <Row className="content__left__input p-3">
            <Col lg="8" md="7" sm="12" className="input-holder mt-3">
                <div className='rotulo'>
                    {t('CampoBusca')}
                </div>
                <Input
                    innerRef={searchInputRef}
                    type="search"
                    className="rad10 b-tema20 cortxt foco"
                    name="q"
                    value={
                        opcoesConsulta.length
                            ? opcoesConsulta[0]?.termo ?? ''
                            : ''
                    }
                    onChange={e => handleTextChange(e)}
                    placeholder={t('DigiteSuaBuscaAqui')}
                    invalid={error}
                />
                <div className="invalid-feedback">
                    {t('CampoBuscaObrigatorio')}
                </div>
            </Col>
            <Col lg="2" md="3" sm="12" className="input-holder mt-3">
                <div className='rotulo'>
                    {t('TipoPesquisas')}
                </div>
                <Input
                    type="select"
                    className="b-tema20 cortxt rad10 s14"
                    name="for"
                    value={
                        opcoesConsulta.length
                            ? opcoesConsulta[0].option
                            : ''
                    }
                    onChange={e => handleComboChange(e)}
                >
                    {termos.map(termo => (
                        <option
                            key={`termo-${termo.value}`}
                            value={termo.value}
                        >
                            {termo.label}
                        </option>
                    ))}
                </Input>
            </Col>
            <Col
                md="2"
                lg="2"
                sm="12"
                className={classnames(' mt-3 align-self-end pb-0', { 'mb-4': error })}
            >
                <Button
                    title="Pesquisar"
                    icon="search"
                    variant='primeiro ml-0 btn-responsivo'
                    type="submit"
                    disabled={loading}
                />
            </Col>
        </Row>
    );
};

export default PesquisaNovasAquisicoes;
